import { API_URL } from "../../../../common/data/GlobalData.js";
import { GUID } from "../Common.js";
const FileUpload = await import(/* webpackChunkName: "FileUpload" */"./FileUpload.js").then(mod => mod.FileUpload);
const Base64toBlob = await import(/* webpackChunkName: "Base64toBlob" */"./Base64toBlob.js").then(mod => mod.Base64toBlob);
const GetContentTypeByFileName = await import(/* webpackChunkName: "GetContentTypeByFileName" */"./GetContentTypeByFileName.js").then(mod => mod.GetContentTypeByFileName);
export const UploadFile = (blobFile, folder, fileName, postEvt) => {
  const FileData = GUID();
  if (blobFile && fileName) {
    const data = {
      blobFile: blobFile instanceof Blob ? blobFile : Base64toBlob(blobFile.substring(blobFile.indexOf(",") + 1), GetContentTypeByFileName(fileName).split("/")[0], fileName),
      fileName
    };
    FileUpload([API_URL, "UploadFile/", fileName, "/", folder].join(""), data, FileData, postEvt);
  }
};